<template>
  <div id="app">
    <router-view :key="$route.path"></router-view>
    <vue-progress-bar></vue-progress-bar>
  </div>
</template>

<script>
export default {
  name: 'App',
  metaInfo: {
    title: 'Main',
    // all titles will be injected into this template
    titleTemplate: '%s | Potpourri',
  },
  mounted() {
    // Refresh data when the driver comes back to the tour plan page after
    // backgrounding the browser (e.g. switching to Maps and back). "pageshow"
    // with persisted only fires on browser back/forward navigation, not on
    // OS-level app switching, so visibilitychange is the reliable signal for
    // "the tab is visible again" and covers bfcache restores too.
    const refreshTourPlanView = () => {
      if (this.$route.name === 'tour-plans.view') {
        this.$root.$emit('tour-plan-view::refresh');
      }
    };
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        refreshTourPlanView();
      }
    });
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
        refreshTourPlanView();
      }
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue